/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect } from "react";
import ReactApexChart from "react-apexcharts";

function BarViewChart({ data }: any) {
  const [state, setState] = React.useState<any>({
    series: [
      {
        data: [0],
      },
    ],
    options: {
      chart: {
        type: "bar",
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [""],
      },
    },
  });

  useEffect(() => {
    if (data?.length) {
      setState((prevState: any) => ({
        options: {
          ...prevState.options,
          xaxis: {
            categories: data.map((c: any) => c.description),
          },
        },
        series: data.map((c: any) => c.amount),
      }));
    }
  }, [data]);

  return state.series.length ? (
    <ReactApexChart
      options={state.options}
      series={state.series}
      type="bar"
      height={340}
    />
  ) : null;
}

export default BarViewChart;
